import api from '../api';
import { ApiError } from './types';

export type TermosCondicoesTipo = 'AGENDAMENTO' | 'ASSINATURA' | 'AMBOS';

export interface TermosCondicoes {
  id: number;
  tipo: TermosCondicoesTipo;
  versao: number;
  titulo: string;
  conteudo: string;
  status: string;
  enabled: boolean;
  publicado_em?: string;
  publicado_por?: bigint;
  created_at: string;
  updated_at: string;
  created_by?: bigint;
  updated_by?: bigint;
}

export class TermosCondicoesService {
  /**
   * Busca o termo ativo por tipo (público)
   * @param tipo - Tipo do termo (AGENDAMENTO ou ASSINATURA)
   * @returns Promise com o termo ativo ou null
   */
  static async getAtivo(tipo: TermosCondicoesTipo): Promise<TermosCondicoes | null> {
    try {
      const response = await api.get<TermosCondicoes>(`termos-condicoes/ativo/${tipo}`);
      return response.data;
    } catch (error: any) {
      // Se retornar 404, significa que não há termo ativo
      if (error.response?.status === 404) {
        return null;
      }
      throw this.handleApiError(error);
    }
  }

  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): ApiError {
    if (error.response?.data) {
      return {
        message: error.response.data.message || 'Erro na requisição',
        statusCode: error.response.status,
        error: error.response.data.error,
      };
    }

    return {
      message: 'Erro de conexão com o servidor',
      statusCode: 500,
      error: 'Network Error',
    };
  }
}

